import { render, staticRenderFns } from "./ReOrder.vue?vue&type=template&id=b80673a0&"
import script from "./ReOrder.vue?vue&type=script&lang=js&"
export * from "./ReOrder.vue?vue&type=script&lang=js&"
import style0 from "./ReOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b80673a0')) {
      api.createRecord('b80673a0', component.options)
    } else {
      api.reload('b80673a0', component.options)
    }
    module.hot.accept("./ReOrder.vue?vue&type=template&id=b80673a0&", function () {
      api.rerender('b80673a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/Table/ReOrder.vue"
export default component.exports